import type { ApiResponse } from '@/store/types'
import { post } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { UUID } from '@/backend/schema/uuid'

/**
 * Tests AI assisted review instruction on backend
 */
export const testInstruction = async (
  params: {
    team_slug: string
    instruction_id: UUID
    instruction_version_id: UUID
    content: string
  },
  config: {
    useMockResponse: boolean
  },
): Promise<ApiResponse<void> | ParsedError> => {
  if (config.useMockResponse) {
    return new Promise((resolve) => setTimeout(() => resolve({} as ApiResponse<void>), 2000))
  }

  const { team_slug, ...rest } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions/feedback/generate`

  try {
    const response = await post<void>(path, rest)
    return response
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_TEST)
  }
}
